

















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  filters: {
    dateFilter(value: string) {
      const str = value.split('-')
      return `${str[1]}-${str[2]}`
    },
  },
})
export default class List extends Vue {
  @Prop()
  dataList!: any[]

  showDetail(id: string, call_time: string) {
    this.$router.push(`/customer/detail/${id}/${call_time}`)
  }
}
